import type { Prisma } from "@prisma/client";

import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";

export const bidRequest = {
  read: (user: User) => hasCapability(user, "bidRequest.read"),
  readForBuyer: (user: User, buyerOrganizationId: string) =>
    hasCapability(user, "bidRequest.read") &&
    (hasCapability(user, "bidRequest.read.all") || user.person.organizationId === buyerOrganizationId),
  create: (user: User) => hasCapability(user, "bidRequest.create"),
  update: (user: User) => hasCapability(user, "bidRequest.update"),
  /** Adjusters are sometimes assigned another carrier's claims (a Branch adjuster on American Family's), so the
   * assignment alone opens a request. */
  updateAssignment: (user: User, parties: { buyerOrganizationId: string; adjusterIds: readonly string[] }) =>
    hasCapability(user, "bidRequest.update") &&
    (hasCapability(user, "bidRequest.updateStatus.all") ||
      user.person.organizationId === parties.buyerOrganizationId ||
      parties.adjusterIds.includes(user.person.id)),
  updateStatus: (user: User, buyerOrganizationId: string) => {
    if (hasCapability(user, "bidRequest.updateStatus.all")) {
      return true;
    }
    if (hasCapability(user, "bidRequest.updateStatus.org")) {
      return user.person.organizationId === buyerOrganizationId;
    }
    return false;
  },
};

export const bidRequestWhere = (user: User) => {
  if (hasCapability(user, "bidRequest.read.all")) {
    return {};
  }

  const clauses: Prisma.BidRequestWhereInput[] = [];

  if (hasCapability(user, "bidRequest.read.org")) {
    clauses.push({ buyerOrganizationId: user.person.organizationId });
  }

  if (clauses.length === 0) {
    return { AND: [{ id: NON_EXISTENT_ID }] };
  }
  return { OR: clauses };
};
